// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I6ns","badges":"styles_badges__pAB3X"};